import React from 'react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { volumes } from '../../data/content';
export function Volumes() {
  return <Section data-id="element-286" data-mp="2x104aphl813t">
      <Eyebrow data-id="element-287" data-mp="2x0qm3o2say8o">Everything you need to make better welding decisions</Eyebrow>
      <Heading data-id="element-288" data-mp="2szom3511mi5n">6 Master Volumes</Heading>

      <ol className="mt-9 space-y-4" data-id="element-289" data-mp="2syn22b21ulbs">
        {volumes.map(v => <li key={v.number} className="relative overflow-hidden rounded-2xl border border-ink-600 bg-ink-800 p-5 pt-6" data-id="element-290" data-mp="2o13lv5lsjyh7">
            <span className="font-display text-5xl font-extrabold leading-none text-flame-500/25" data-id="element-291" data-mp="2j8k5k0vpyp8p">
              {v.number}
            </span>
            <h3 className="mt-1 font-display text-2xl font-extrabold uppercase leading-tight tracking-wide text-white sm:text-3xl" data-id="element-292" data-mp="29c7fre3aovj8">
              {v.title}
            </h3>
            <p className="mt-2 font-display text-base font-bold uppercase tracking-wide text-spark sm:text-lg" data-id="element-293" data-mp="25bwyh5a1yip2">
              {v.tagline}
            </p>
            {v.body.map(p => <p key={p} className="mt-3 text-[15px] leading-relaxed text-zinc-300" data-id="element-294" data-mp="333jfi0g6fg58">
                {p}
              </p>)}
            {v.extra ? <p className="mt-4 border-t border-ink-600 pt-3 text-[13px] font-semibold leading-snug text-zinc-400" data-id="element-295" data-mp="2u6932brmhkyq">
                {v.extra}
              </p> : null}
          </li>)}
      </ol>

      <p className="mt-9 text-center font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-296" data-mp="3lwnem1c5yl78">
        Get all 6 Master Volumes in minutes
      </p>

      <div className="mt-4" data-id="element-297" data-mp="3cue43bgwartu">
        <CTAButton data-id="element-298" data-mp="3cv60goibgtl6" />
      </div>
    </Section>;
}